/*
 * @Author: Yang Zhang
 * @Date: 2022-06-15 18:06:33
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-01-31 18:28:26
 * @Description:
 */
import { simpleRequest } from '@/utils/simpleRequest'

import { request } from '@/utils/request'

const api = {
  storage_nodes: '/storageNodes',
  publish: '/publish/type'
}

const baseURL = '/storage'

export type TStorageNodeQueryParams = {
  /** 通过id查询存储节点 */
  id?: number
  page?: number
  pageSize?: number
  isMaster?: 0 | 1
  location?: string
}

type TGetStorageNodesResponse = {
  data: TStorageNode[]
  page: number
  pageSize: number
  total: number
}

/** 存储节点查询 */
export const getStorageNodesList = (params?: TStorageNodeQueryParams) => {
  return request({
    url: api.storage_nodes,
    method: 'get',
    baseUrl: baseURL,
    params: params
  })
}

export function getMasterNodes() {
  return simpleRequest<TGetStorageNodesResponse>({
    url: api.storage_nodes,
    params: {
      isMaster: 1
    },
    method: 'GET',
    baseURL
  })
}

export function getPrivateNodes() {
  return simpleRequest<TGetStorageNodesResponse>({
    url: api.storage_nodes,
    params: {
      location: '深圳'
    },
    method: 'GET',
    baseURL
  })
}

/** 删除存储节点 */
export function deleteStorageNode(data: { idList: number[] }) {
  return simpleRequest<{ delete_count: number }>({
    url: api.storage_nodes,
    data,
    method: 'DELETE',
    baseURL
  })
}

export type TCreateStorageNodePayload = {
  // connectStatus: number
  isMaster: number
  location: string
  name: string
  privateUrl: string
  publicUrl: string
}

export type TStorageNode = {
  id: number
  storageNodeId: string
  name: string
  location: string
  publicUrl: string
  privateUrl: string
  isMaster: number
  connectStatus: number
}

/** 添加存储节点 */
export function createStorageNode(data: TCreateStorageNodePayload) {
  return simpleRequest<TStorageNode>({
    url: api.storage_nodes,
    method: 'POST',
    data,
    baseURL
  })
}

export type TUpdateStorageNode = TCreateStorageNodePayload & { id: number }

/** 存储节点修改 */

export const updateStorageNodeInfo = (data: TUpdateStorageNode) => {
  return request({
    url: api.storage_nodes + '/' + data.id,
    method: 'put',
    data,
    baseUrl: baseURL
  })
}

// 获取发布产品类型
export const getPublishType = () => {
  return request({
    url: api.publish,
    method: 'get',
    baseUrl: baseURL
  })
}
